export default __webpack_public_path__ + "img/6f9173ccd100afbabf1c6f25ef9154e1.svg";